/* eslint-disable */ 

export default {
    state: { 
        reset: {
            loading: false,
            errMessage: "",
            successMessage: ""
        }
    },
    mutations: {
        'RESET_LOADING': (state, val) => {
            state.reset.loading = val;
        },
        'RESET_SUCCESS': (_, email) => {
            window.location.href = "/login?email="+email;
        },
        'RESET_ERROR': (state, val) => {
            state.reset.errMessage = val;
            state.reset.successMessage = "";
        }
    },
    actions: {
        'RESET_SUBMIT': ({commit, rootState}, data) => {
            commit('RESET_LOADING', true);
            axios.put(`/reset?resetID=${data.resetID}`, data.payload)
                .then(resp => {
                    commit('RESET_LOADING', false);
                    commit('RESET_SUCCESS', data.email);
                    console.log(resp);
                })
                .catch(err => {
                    const errTxt = err.response ? (err.response.data ? (err.response.data.errTxt ? err.response.data.errTxt : undefined): undefined) : undefined;
                    const enText = errTxt ? errTxt : "Error, something went wrong try again.", fiText = errTxt ? errTxt : "Virhe, jokin meni pieleen.";
                    commit('RESET_LOADING', false);
                    commit('RESET_ERROR', rootState.locale === "en" ? enText : fiText);
                    console.log(err.response);
                });
        }
    }
}